export default class DefaultFieldsConfiguration {
	constructor(
		public inncashApiFieldTypes: string[],
		public innmergeApiFieldName: string | undefined,
		public inncashApiFieldName: string,
		public databaseFieldName: string,
		public updateFieldFormat: string | undefined,
	) { }

	static make(data: any): DefaultFieldsConfiguration {
		return new DefaultFieldsConfiguration(
			data.inncash_api_field_types,
			data.innmerge_api_field_name,
			data.inncash_api_field_name,
			data.database_field_name,
			data.update_field_format,
		);
	}
}
